// extracted by mini-css-extract-plugin
module.exports = {"container":"_2rHv3hYn7batz6cS8UDnZd","groupsList":"_2Qv65iE-_sOej7T2t73aCM"};